import { BriefcaseBusiness, UserRound, UsersRound } from 'lucide-react';
import { useI18n } from '../i18n/useI18n';

const audiences = [
  { icon: UserRound, title: 'audience.personal.title', text: 'audience.personal.text' },
  { icon: BriefcaseBusiness, title: 'audience.business.title', text: 'audience.business.text' },
  { icon: UsersRound, title: 'audience.pro.title', text: 'audience.pro.text' },
];

export function AudienceSection() {
  const { t } = useI18n();

  return (
    <section className="section">
      <div className="section-heading">
        <p className="eyebrow">{t('audience.eyebrow')}</p>
        <h2>{t('audience.title')}</h2>
      </div>
      <div className="three-grid">
        {audiences.map((audience) => {
          const Icon = audience.icon;
          return (
            <article className="info-card" key={audience.title}>
              <Icon size={24} />
              <h3>{t(audience.title)}</h3>
              <p>{t(audience.text)}</p>
            </article>
          );
        })}
      </div>
    </section>
  );
}
